import React from "react";
import { Check } from "lucide-react";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container about-grid">
        <div className="about-card">
          <div className="avatar avatar-photo">
            <img src="https://customer-assets-0z36b82j.emergentagent.net/job_freight-match-38/artifacts/chb6sj8q_23D44766-F951-409C-9758-F36FB4C4BE78.png" alt="Jayla Duff, Owner and Dispatcher" />
          </div>
          <h3>Jayla Duff</h3>
          <div className="role">Owner / Dispatcher</div>
          <div className="about-services">
            <span className="svc-pill">Freight Forwarding</span>
            <span className="svc-pill">Carrier Sourcing</span>
            <span className="svc-pill">Dispatcher Services</span>
          </div>
          <p className="quote">"Every truck I dispatch is one I'd trust with my own freight. That's the standard we hold every load to."</p>
        </div>
        <div className="about-copy">
          <span className="kicker">About Flying Fleet Dispatch</span>
          <h2>Owner-operated. Personally dispatched.</h2>
          <p>Flying Fleet Dispatch LLC was built on one idea: carriers do better when someone's actually handling the details &mdash; the calls, the rate negotiations, the paperwork &mdash; so drivers can stay focused on the road.</p>
          <p>Owner and dispatcher Jayla Duff works directly with every carrier on the fleet, sourcing freight, securing exclusive broker loads, and keeping trucks moving with dedicated, hands-on dispatch support.</p>
          <ul className="check-list">
            <li><Check strokeWidth={2.4} />Direct, one-on-one dispatch support</li>
            <li><Check strokeWidth={2.4} />Access to exclusive broker-only freight</li>
            <li><Check strokeWidth={2.4} />Rate negotiation on every load</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
